module.exports = __webpack_public_path__ + "img/okvir.3a857bec.png";